import type { FilterShortDTO, NutritionShortDTO } from 'shared/types/api'

export const productTypes = {
    MENU: 0,
    BURGER: 1,
    SNACK: 2,
    KIDS: 3
}

export const MenuType = {
    SIDE: 0,
    DRINK: 1,
    MAIN: 2,
    OTHERS: 3
}

export type MenuElement = {
    name: string,
    selected: boolean,
    image: Array<string>,
    noAllergens: boolean,
    allergens: Array<FilterShortDTO>,
    traces: Array<FilterShortDTO>,
    nutrition: Array<NutritionShortDTO>
}

export type MenuSection = {
    selected: boolean,
    type: number,
    elements: Array<MenuElement>
}
